/**
 * Booklet JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Booklet
 */
export default class Booklet {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {

    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.$tabs  = $( '.js-booklet-tab' );
        this.$forms = $( '.js-booklet-form' );
        this.tabId  = 0;
    }

    /**
     * Run events.
     */
    events() {
        this.$tabs.on( 'click', ( elem ) => {
            this.changeTab( elem );
        });
    }

    /**
     * Handle booklet tab change.
     *
     * @param {object} elem Event object.
     */
    changeTab( elem ) {
        const $tab   = $( elem.target );
        const tabId  = $tab.data( 'tab-id' );

        // Handle tab change only if clicked tab is not current tab.
        if ( this.tabId != tabId ) {
            this.toggleActiveTab( $tab );
            this.toggleForm( tabId );

            // Update current tab id.
            this.tabId = $tab.data( 'tab-id' );
        }
    }

    /**
     * Toggles active class for bookelt tab.
     *
     * @param {object} $tab Tab object.
     */
    toggleActiveTab( $tab ) {

        // Remove active class from all tabs.
        this.$tabs.removeClass( 'active' );

        // Add active tab for clicked tab.
        $tab.addClass( 'active' );
    }

    /**
     * Toggles form element.
     *
     * @param {int} tabId Tab id.
     */
    toggleForm( tabId ) {

        // Hide all forms.
        this.$forms.hide();

        // Show clicked form.
        this.$forms.each( function() {
            const $form = $( this );

            if ( $form.data( 'form-id' ) == tabId ) {
                $form.show();
            }
        });
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/booklet.js